import {
  Autocomplete,
  Box,
  Button,
  Chip,
  ClickAwayListener,
  Grid,
  TextField,
} from '@mui/material';
import moment from 'moment';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  CANCEL_BUTTON_TEXT,
  SHOW_NOTIFICATION,
  SUBMIT_BUTTON_TEXT,
} from '../../constants';
import DateRangeComponent from '../../components/DateRangePicker/DateRangeComponent';

import { SUBJECT_LABEL, SUBJECT_PLACEHOLDER } from '../Leaves/LeavesConstants';
import React, { useEffect } from 'react';
import { getUsers } from '../../services/UserService';

import { useDispatch } from 'react-redux';
import KeycloakService from '../../services/KeycloakService';
import { applyWFH } from '../../services/WFHService.js';
import { SET_DATE_RANGE } from './TaskConstants';
import { MAIN_BLUE } from '../../color';
import { getEmployeeWfhQuota } from '../../admin/Services/EmployeePrivilegesService.js';
import { getSummary } from '../../services/TimingService.js';
import { getUserData } from '../../services/UserService.js';

const ApplyWFHFields = (props) => {
  const {
    toggleOpen,
    presetRecipients,
    getWFHApplicationList,
    editableWFH,
    editable,
    editRecipients,
    officialHolidays,
    leavesList,
  } = props;

  const leaveDates = [];
  leavesList.map((leave) => {
    const currentDay = new Date(leave.startDate);
    const endDate = new Date(leave.endDate);
    while (currentDay <= endDate) {
      const currentDateStr = moment(currentDay).format('DD MM YYYY');
      const isWeekend =
        moment(currentDay).day() === 0 || moment(currentDay).day() === 6;
      const isHoliday =
        officialHolidays.findIndex((holiday) => {
          return holiday === currentDateStr;
        }) !== -1;
      if (!isWeekend && !isHoliday) {
        leaveDates.push(currentDateStr);
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }
  });

  const [recipients, setRecipients] = React.useState([...presetRecipients]);
  const [search, setSearch] = React.useState(false);
  const [inputValue, setInputValue] = React.useState('');
  const [wfhReason, setWfhReason] = React.useState('');
  const [loadingApiCall, setLoadingApiCall] = React.useState(false);

  const [fieldError, setFieldError] = React.useState({
    subjects: false,
    reason: false,
    dateRange: false,
  });
  const [errorMsg, setErrorMsg] = React.useState({
    subjects: '',
    reason: '',
    dateRange: '',
  });

  const [toSubjects, setToSubjects] = React.useState([]);
  const [dateRange, setDateRange] = React.useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const currentUserId = () => KeycloakService.getUserDetail();
  const employeeId = KeycloakService.getUserDetail();

  const applyWfhFunction = async () => {
    if (dataValidation()) {
      setLoadingApiCall(true);
      const wfhPayload = applyWFHPayload();
      const createWfhResponse = await applyWFH(wfhPayload);
      setLoadingApiCall(false);
      dipatchNotification(createWfhResponse.type, createWfhResponse.message);
      if (createWfhResponse.isError === false) {
        toggleOpen();
        getWFHApplicationList();
      }
    }
  };
  const getQuarter = (date) => {
    const month = moment(date).month();
    if (month >= 0 && month <= 2) return 0;
    if (month >= 3 && month <= 5) return 1;
    if (month >= 6 && month <= 8) return 2;
    return 3;
  };

  const getQuarterDateRange = (year, quarter) => {
    const ranges = {
      0: [`${year}-01-01`, `${year}-03-31`],
      1: [`${year}-04-01`, `${year}-06-30`],
      2: [`${year}-07-01`, `${year}-09-30`],
      3: [`${year}-10-01`, `${year}-12-31`],
    };
    return ranges[quarter];
  };

  const handleSubmit = async () => {
    try {

      const startDate = moment(dateRange.startDate).format('YYYY-MM-DD');
      const endDateMoment = moment(dateRange.endDate);
      const endDate = endDateMoment.format('YYYY-MM-DD');
      const year = endDateMoment.year();

      const startQuarter = getQuarter(startDate);
      const endQuarter = getQuarter(endDate);
      let isQuotaExceeded = false;
      const holidays = officialHolidays.map((dateStr) =>
        moment(dateStr, 'DD MM YYYY').format('YYYY-MM-DD'),
      );

      let totalAllowedQuota = 0;
      let totalUsedQuota = 0;
      const countWorkingDays = (start, end) => {
        let count = 0;
        let current = moment(start);
        while (current.isSameOrBefore(end, 'day')) {
          const dayOfWeek = current.isoWeekday();
          const currentDateStr = current.format('YYYY-MM-DD');

          if (
            dayOfWeek !== 6 &&
            dayOfWeek !== 7 &&
            !holidays.includes(currentDateStr)
          ) {
            count++;
          }
          current.add(1, 'day');
        }
        return count;
      };

      const totalDays = countWorkingDays(startDate, endDate);
      for (let quarter = startQuarter; quarter <= endQuarter; quarter++) {
        const [quarterStart, quarterEnd] = getQuarterDateRange(year, quarter);

        const employeeWFHQuota = await getEmployeeWfhQuota(year, employeeId);
        let wfhQuota = employeeWFHQuota.data.data.quotaWFH.thisYear;

        totalAllowedQuota += wfhQuota[quarter];

        const summaryData = await getSummary(
          quarterStart,
          quarterEnd,
          employeeId,
        );
        let wfhDays = summaryData.data.workFromHomeDaysWithPending;
        totalUsedQuota += wfhDays || 0;

        const editStartDate = editableWFH?.startDate;
        const editEndDate = editableWFH?.endDate;
        const editStartQuarter = getQuarter(editStartDate);
        const editEndQuarter = getQuarter(editEndDate);
        let removalCount = 0;

        let startQuarterDays = 0;

        if (startQuarter === quarter && endQuarter !== quarter) {
          startQuarterDays = countWorkingDays(startDate, quarterEnd);
        }
        // const removalStartDateCount = 0;
        // const removalEndDateCount = 0;
        if (editable) {
          if (editStartQuarter === quarter && editEndQuarter === quarter) {
            removalCount = countWorkingDays(editStartDate, editEndDate);
          } else if (
            editStartQuarter === quarter &&
            editEndQuarter !== quarter
          ) {
            removalCount = countWorkingDays(editStartDate, quarterEnd);
          } else if (
            editStartQuarter !== quarter &&
            editEndQuarter === quarter
          ) {
            removalCount = countWorkingDays(quarterStart, editEndDate);
          }
        }

        // const ediableWfhCount = countWorkingDays(
        //   editableWFH.startDate,
        //   editableWFH.endDate,
        // );
        totalUsedQuota =
          editableWFH?.status === 'REJECTED'
            ? totalUsedQuota
            : totalUsedQuota - removalCount;
        if (totalUsedQuota + startQuarterDays > totalAllowedQuota) {
          isQuotaExceeded = true;
        }
      }
      const condition = totalUsedQuota + totalDays;
      if (isQuotaExceeded || condition > totalAllowedQuota) {
        dipatchNotification(
          'error',
          'WFH Quota exceeded for the selected period.',
        );
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  };

  const dataValidation = () => {
    setFieldError(false);
    setErrorMsg('');

    let newReason = wfhReason;

    // if (recipients.length < 1) {
    //   setFieldError((prev) => {
    //     return { ...prev, subjects: true };
    //   });
    //   setErrorMsg((prev) => {
    //     return { ...prev, subjects: '*Invalid input' };
    //   });

    //   return false;
    // } else
    if (
      wfhReason.indexOf(wfhReason.trim()) != 0 ||
      wfhReason.trim().length < 10
    ) {
      setFieldError((prev) => {
        return { ...prev, reason: true };
      });
      setErrorMsg((prev) => {
        return { ...prev, reason: '*Please enter at least 10 characters' };
      });
      return false;
    }
    return true;
  };

  const getBusinessDays = (start, end) => {
    const holidays = officialHolidays.map((dateStr) =>
      moment(dateStr, 'DD MM YYYY').format('YYYY-MM-DD'),
    );

    // const pendingAndApprovedLeavs = leaveDates.map((dateStr) => {
    //   return moment(dateStr, 'DD MM YYYY').format('YYYY-MM-DD');
    // });

    let count = 0;
    let current = moment(start);
    while (current.isSameOrBefore(end, 'day')) {
      const dayOfWeek = current.isoWeekday();
      const currentDateStr = current.format('YYYY-MM-DD');

      if (
        dayOfWeek !== 6 &&
        dayOfWeek !== 7 &&
        !holidays.includes(currentDateStr)
        // !pendingAndApprovedLeavs.includes(currentDateStr)
      ) {
        count++;
      }
      // count++;
      current.add(1, 'day');
    }
    return count;
  };

  const editWFH = async (wfh, editRecipients1) => {
    const arr = presetRecipients.map((val) => val.id);
    setRecipients(() => [
      ...presetRecipients,
      ...editRecipients1.filter((val) => !arr.includes(val.id)),
    ]);

    setWfhReason(wfh.reason);
    setDateRange({
      startDate: wfh.startDate,
      endDate: wfh.endDate,
    });
    dispatch({
      type: SET_DATE_RANGE,
      data: {
        startDate: new Date(wfh.startDate).toISOString(),
        endDate: new Date(wfh.endDate).toISOString(),
        key: '',
        color: MAIN_BLUE,
      },
    });
  };

  const recipientField = async () => {
    if (editable) {
      editWFH(editableWFH, editRecipients);
    }
  };

  const editWfhFunction = async () => {
    const updatedLeavePayload = editWfhPayload();
    setLoadingApiCall(true);
    const editWfhResponse = await applyWFH(updatedLeavePayload);
    setLoadingApiCall(false);
    dipatchNotification(editWfhResponse.type, editWfhResponse.message);
    if (editWfhResponse.isError === false) {
      toggleOpen();
      getWFHApplicationList();
    }
  };

  const editWfhPayload = () => {
    return {
      id: editableWFH.id,
      employeeId: currentUserId(),
      type: 'WFH',
      reason: wfhReason,
      status: 'PENDING',
      isUpdatedByAdmin: false,
      startDate: moment(dateRange.startDate).format('YYYY-MM-DD'),
      endDate: moment(dateRange.endDate).format('YYYY-MM-DD'),
      applicationStatusDTOS: recipients.map((recipient) => {
        return {
          type: 'WFH',
          approverId: recipient.id,
          status: 'PENDING',
        };
      }),
    };
  };

  const applyWFHPayload = () => {
    return {
      employeeId: currentUserId(),
      type: 'WFH',
      reason: wfhReason,
      status: 'PENDING',
      isUpdatedByAdmin: false,
      startDate: moment(dateRange.startDate).format('YYYY-MM-DD'),
      endDate: moment(dateRange.endDate).format('YYYY-MM-DD'),
      applicationStatusDTOS: recipients.map((recipient) => {
        return {
          type: 'WFH',
          approverId: recipient.id,
          status: 'PENDING',
        };
      }),
    };
  };
  const dispatch = useDispatch();

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const loadData = async () => {
    const subjects = await getUsers('');
    if (subjects.status !== 200) {
      dipatchNotification(subjects.type, subjects.message);
    }
    if (subjects.isError === false) {
      setToSubjects(() => subjects.data.content);
    }
    recipientField();
  };

  const checkOptions = (str) => {
    if (str?.length > 1) {
      setSearch(true);
    } else {
      setSearch(false);
    }
  };

  const handleCloseDropdown = (event) => {
    setSearch(false);
  };

  const handleClickAway = () => {
    setSearch(false);
  };

  const editRange = (wfh) => {
    return {
      startDate: new Date(wfh.startDate),
      endDate: new Date(wfh.endDate),
    };
  };

  const onDateRangeSelection = (item) => {
    setDateRange((data) => {
      return {
        ...data,

        startDate: item.startDate,
        endDate: item.endDate,
      };
    });
  };

  const style = {
    display: 'flex',
    '@media only screen and (max-width: 900px)': {
      '.apply-leaves-field': {
        width: '40%',
      },
      '.date-range-picker': {
        width: '60%',
      },
    },
    '@media only screen and (max-width: 700px)': {
      '.apply-leaves-field': {
        width: '40%',
      },
      '.date-range-picker': {
        width: '60%',
      },
      '.rdrMonth': {
        width: '100%',
      },
    },
    '@media only screen and (max-width: 580px)': {
      display: 'block',
      '.apply-leaves-field': {
        width: '100%',
      },
      '.date-range-picker': {
        width: '100%',
        justifyContent: 'center',
      },
      '.rdrMonth': {
        width: '100%',
      },
    },
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div>
      <Box className="main-content-overlay" style={{ padding: '2% 5%' }}>
        <ClickAwayListener onClickAway={handleClickAway}>
          <Autocomplete
            forcePopupIcon={false}
            multiple
            disableClearable
            id="multi-subjects"
            open={search}
            isOptionEqualToValue={(option, value) =>
              option.firstName + ' ' + option.lastName ===
              value.firstName + ' ' + value.lastName
            }
            options={toSubjects}
            getOptionLabel={(option) =>
              option.firstName + ' ' + option.lastName
            }
            onBlur={handleCloseDropdown}
            inputValue={inputValue}
            onInputChange={(e) => {
              const inputValue = e?.target?.value;
              setInputValue(inputValue);
              checkOptions(inputValue);
            }}
            value={recipients}
            onChange={(e, val) => {
              setRecipients((prevRecs) => [
                ...presetRecipients,
                ...val.filter(
                  (option) => presetRecipients.indexOf(option) === -1,
                ),
              ]);
              setInputValue('');
              setSearch(false);
            }}
            filterSelectedOptions
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => (
                <Chip
                  key={index}
                  disabled={editable}
                  label={option.firstName + ' ' + option.lastName}
                  {...(presetRecipients.indexOf(option) === -1
                    ? getTagProps({ index })
                    : '')}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={SUBJECT_LABEL}
                InputLabelProps={{
                  shrink: !(inputValue === '' && recipients.length === 0),
                }}
                // placeholder={SUBJECT_PLACEHOLDER}
                error={fieldError.subjects}
                helperText={errorMsg.subjects}
              />
            )}
            sx={{ mt: 2 }}
            disabled={true}
          />
        </ClickAwayListener>

        <Box sx={style}>
          <Grid
            container
            justifyContent="left"
            className="date-range-picker"
            sx={{ mt: 2, width: '45%' }}
          >
            {
              // editable ? (
              //   <DateRangeComponent
              //     onDateRangeSelection={onDateRangeSelection}
              //     // minDate={new Date()}
              //     start={editRange(editableWFH).startDate}
              //     end={editRange(editableWFH).endDate}
              //   />
              // ) : (
              <DateRangeComponent
                disableWeekends={true}
                officialHolidays={officialHolidays}
                leavesList={leavesList}
                onDateRangeSelection={onDateRangeSelection}
                minDate={
                  new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() - 6,
                    new Date().getDate(),
                  )
                }
                start={new Date()}
                end={new Date()}
                wfhEditable={editable}
              />
              // )
            }
          </Grid>
          <Grid sx={{ mt: 1, width: '55%' }}>
            {/* <FormControl fullWidth sx={{ mt: 2 }}>
                  <InputLabel>{LEAVE_TYPE_LABEL}</InputLabel>
                  <Select
                    id="leave-type-select"
                    value={leaveType}
                    label="Leave Type"
                    onChange={(e) => setLeaveType(e.target.value)}
                  >
                    <MenuItem value="CASUAL_LEAVE">Casual</MenuItem>
                    <MenuItem value="WFH">WFH</MenuItem>
                  </Select>
                </FormControl> */}
            <TextField
              id="reason-field"
              label="Reason"
              multiline
              error={fieldError.reason}
              helperText={errorMsg.reason}
              fullWidth
              sx={{ mt: 2 }}
              value={wfhReason}
              onChange={(e) => {
                setWfhReason(e.target.value);
                // setLeaveError(false);
              }}
              rows={12}
            />
          </Grid>
        </Box>
        <div className="space-between-container">
          <Button variant="outlined" color="error" onClick={toggleOpen}>
            {CANCEL_BUTTON_TEXT}
          </Button>
          <LoadingButton
            loading={loadingApiCall}
            variant="contained"
            onClick={async () => {
              setLoadingApiCall(true);
              try {
                const isQuotaValid = await handleSubmit();
                if (isQuotaValid) {
                  if (editable) {
                    await editWfhFunction();
                  } else {
                    await applyWfhFunction();
                  }
                }
              } catch (error) {
                console.error('An error occurred:', error);
              } finally {
                setLoadingApiCall(false);
              }
            }}
          >
            {loadingApiCall ? 'loading...' : SUBMIT_BUTTON_TEXT}
          </LoadingButton>
        </div>
      </Box>
    </div>
  );
};
export default ApplyWFHFields;
